import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';
import { Heading, Text } from '../primitives';

const Card = styled.article`
  padding: ${tokens.spacing.lg};
  border-radius: ${tokens.radius.md};
  background: ${tokens.colors.background};
  box-shadow: ${tokens.shadows.sm};
  border: 1px solid ${tokens.colors.border};
`;

export function FeatureCard({ title, description, children, ...props }) {
  return (
    <Card {...props}>
      {title && <Heading level={3}>{title}</Heading>}
      {description && <Text>{description}</Text>}
      {children}
    </Card>
  );
}

export default FeatureCard;
